import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  SurveyAllResponsesComponent
} from '../../../components/surveys/survey-all-responses/survey-all-responses.component';
import {MatTabGroup} from "@angular/material/tabs";
import {SurveyService} from "../../../services/surveys.service";
import {SurveyDetailsComponent} from "../../../components/surveys/survey-details/survey-details.component";

@Component({
    selector: 'app-survey-details-page',
    templateUrl: './survey-details-page.component.html',
    styleUrls: ['./survey-details-page.component.scss'],
    standalone: false
})
export class SurveyDetailsPageComponent implements OnInit {
  @ViewChild('allResponsesComponent') allResponsesComponent: SurveyAllResponsesComponent;
  @ViewChild(SurveyDetailsComponent) surveyDetailsComponent: SurveyDetailsComponent;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @Input() surveyId: any;
  @Input() noButtons = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private surveyService: SurveyService,
  ) {
  }

  survey_id = null;
  survey = null;

  ngOnInit(): void {
    this.init();
  }

  init() {
    if (this.surveyId) {
      this.survey_id = this.surveyId
    } else {
      this.route.params.subscribe(params => {
        this.survey_id = params.survey_id;
      });
    }
  }

  onSurveyChanged(survey) {
    this.survey = survey;
  }

  backToProject(survey) {
    if (survey) {
      if (survey?.organization_project_id) {
        this.router.navigate(['/projects/' + survey.organization_project_id]);
      } else {
        this.router.navigate(['/']);
      }
    }
  }


  surveyNodeCLicked(data) {
    this.router.navigate(['/surveys/' + data?.surveyID]);
    this.init();
  }

  get consensusQuestionsExist() {
    return this.survey?.questions?.some((qst) => this.surveyService.isConsensusQuestion(qst.typology))
  }

  reloadSurvey() {
    if (this.surveyDetailsComponent) {
      this.surveyDetailsComponent.getSurvey();
    }
  }
}
